export default __webpack_public_path__ + "static/media/contact.de4d21c3.png";